export default "__VITE_ASSET__eccb7130__"